module.exports = __webpack_public_path__ + "img/cal.39f68ecc.png";